import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';
import { useRetrieveSelectListOptions } from 'src/compass/shared/components/CasSelect/CasEntitySelect';
import { EntityListOptionsProps } from 'src/compass/shared/hooks/reactQuery/useRetrieveEntityListOptions';

const entity = "Employee/RiskManager";

// includeBusDev adds the Bus Dev employees - the Service Owner choices for a customer with no
// Risk Managers yet.
type RiskManagerListProps = { limitBusDev?: boolean; includeBusDev?: boolean };

export function useRiskManagerOptions({
  limitBusDev = false,
  includeBusDev = false,
  ...props
}: EntityListOptionsProps & RiskManagerListProps) {
  return useRetrieveSelectListOptions(entity, {
    ...props,
    params: { ...props.params, limitBusDev, includeBusDev },
  });
}

export function CasRHFRiskManagerSelect({
  limitBusDev = false,
  includeBusDev = false,
  ...props
}: CasEntitySelectProps & RiskManagerListProps) {
  return CasEntityRHFSelect(entity, {
    ...props,
    params: { ...props.params, limitBusDev, includeBusDev },
  });
}

export function CasRiskManagerSelect({
  limitBusDev = false,
  includeBusDev = false,
  ...props
}: componentProps & RiskManagerListProps) {
  return CasEntitySelect(entity, { ...props, params: { ...props.params, limitBusDev, includeBusDev } });
}
